var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/shop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/shop_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.2775 27L8.2775 43.2025C8.2775 55.55 13.2275 60.5 25.575 60.5H40.3975C52.745 60.5 57.695 55.55 57.695 43.2025L57.695 27",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33 33C38.0325 33 41.745 28.9025 41.25 23.87L39.435 5.5H26.5925L24.75 23.87C24.255 28.9025 27.9675 33 33 33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M50.3525 33C55.9075 33 59.9775 28.49 59.4275 22.9625L58.6575 15.4C57.6675 8.25 54.9175 5.5 47.7125 5.5H39.325L41.25 24.7775C41.7175 29.315 45.815 33 50.3525 33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.51 33C20.0475 33 24.145 29.315 24.585 24.7775L25.19 18.7L26.51 5.5H18.1225C10.9175 5.5 8.1675 8.25 7.1775 15.4L6.435 22.9625C5.885 28.49 9.955 33 15.51 33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33 46.75C28.4075 46.75 26.125 49.0325 26.125 53.625V60.5H39.875V53.625C39.875 49.0325 37.5925 46.75 33 46.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.3493f2421b2578117662ae6bf1b0dba3.svg";
export { ForwardRef as ReactComponent };